import React from "react";
import { DesignationAPI } from "../api/DesignationAPI";
import {
  EBSelectOption,
  EBSelectOptionDataType,
  EBSelectV2,
} from "../components/common/Form/EBSelectV2";
import { SelectorProps } from "../components/common/Selectors";
import { Designation } from "../model/Designation";

interface DesignationSelectorProps extends SelectorProps {
  designations: Designation[];
}

export interface DesignationSelectorOption
  extends EBSelectOptionDataType,
    Designation {}

export function DesignationSelector(props: DesignationSelectorProps) {
  function onCreate(
    title: string
  ): Promise<EBSelectOption<DesignationSelectorOption>> {
    return DesignationAPI.add({ title: title } as Designation).then(
      (designation) => {
        return {
          label: designation.title,
          value: `${designation.id}`,
          data: {
            ...designation,
            selectOptionValue: `${designation.id}`,
          },
        };
      }
    );
  }
  let options: EBSelectOption<DesignationSelectorOption>[] = [];

  props.designations.forEach((designation: Designation) => {
    options.push({
      label: designation.title,
      value: `${designation.id}`,
      data: {
        ...designation,
        selectOptionValue: `${designation.id}`,
      },
    });
  });

  return (
    <div className="row">
      <div className="col">
        {options && options.length > 0 && (
          <EBSelectV2
            label={props.label}
            name={props.name}
            required={props.required}
            options={options}
            disabled={props.disabled}
            isMulti={props.isMulti}
            onCreate={props.allowCreate ? onCreate : undefined}
            placeholder={props.placeholder}
            isDataEqual={(
              d1: DesignationSelectorOption,
              d2: DesignationSelectorOption
            ) => {
              return d1.id === d2.id;
            }}
          />
        )}
      </div>
    </div>
  );
}
